import React from 'react'
import { Link } from 'react-router-dom'

export const createTitleContentColumns = (t) => {
  const columns = [
    { label: 'orden', key: 'order', className: 'small left-align' },
    { label: t('feedTitleContent'), key: 'title' },
    { label: 'section', key: 'section', className: 'medium' },
    { label: t('feedAsigned'), key: 'feed', className: 'medium' },
    { label: t('feedActions'), key: 'actions', className: 'small right-align' },
  ]
  return columns
}

export const createManageContentColumns = ({ columns, rows, kind, onDelete, t }) => {
  const headerKeys = columns.map((el) => el.key)
  return rows.map((item, key) => {
    return (
      <tr key={key}>
        {headerKeys.map((key, index) => {
          let component
          let className
          if (key === 'id') component = item[key]
          if (key === 'order') component = item.attributes.order
          if (key === 'section') component = item.attributes.section
          if (key === 'title') component = item.attributes.title
          if (key === 'feed') component = item.attributes.feed_name
          if (key === 'actions') {
            className = 'right-align'
            component = (
              <>
                <Link title={t('Editar')} to={`/${kind}/update/${item.id}`} className="fas fa-pen" />
                <i title={t('Borrar')} className="fas fa-trash" onClick={() => onDelete(item)} />
              </>
            )
          }
          return (
            <td className={className} title={component} key={index}>
              {component}
            </td>
          )
        })}
      </tr>
    )
  })
}

export const createTitleFeedsColumns = (t) => {
  const columns = [
    { label: t('feedNameFeed'), key: 'feed', className: 'medium' },
    { label: t('feedUserGroupsAsigned'), key: 'users_groups' },
    { label: t('feedActions'), key: 'actions', className: 'small right-align' },
  ]
  return columns
}

export const createManageFeedColumns = ({ columns, rows, kind, onDelete, t }) => {
  const headerKeys = columns.map((el) => el.key)

  function parseUserGroups(objeto) {
    let codigos = []
    if (objeto.attributes && objeto.attributes.user_group_list) {
      for (let grupo of objeto.attributes.user_group_list) {
        if (grupo.code) codigos.push(grupo.code)
      }
    }
    return codigos.join(', ')
  }

  return rows.map((item, key) => {
    const allUsersGroups = parseUserGroups(item)

    return (
      <tr key={key}>
        {headerKeys.map((key, index) => {
          let component
          let className
          if (key === 'id') component = item[key]
          if (key === 'feed') component = item.attributes.name
          if (key === 'users_groups') component = allUsersGroups

          if (key === 'actions') {
            className = 'right-align'
            component = (
              <>
                <Link title={t('Editar')} to={`/${kind}/update/${item.id}`} className="fas fa-pen" />
                <i title={t('Borrar')} className="fas fa-trash" onClick={() => onDelete(item)} />
              </>
            )
          }
          return (
            <td className={className} title={component} key={index}>
              {component}
            </td>
          )
        })}
      </tr>
    )
  })
}
